import { useRef, useState, useEffect } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

const AddressMap = ({ data, setData, setErrors, type = "" }) => {
  const [options, setOptions] = useState({
    disableDefaultUI: true,
    zoomControl: false,
    panControl: false,
    rotateControl: false,
    scaleControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
    keyboardShortcuts: false,
    gestureHandling: "greedy",
  });
  const [center, setCenter] = useState({
    lat: 29.2266,
    lng: 47.9689,
  });
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
  });
  const mapRef = useRef(null);
  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  useEffect(() => {
    const defaultCenter = { lat: 29.2266, lng: 47.9689 };

    let lat, lng;

    if (type === "billing") {
      lat = parseFloat(data?.billingLatitude);
      lng = parseFloat(data?.billingLongitude);
    } else if (type === "legal") {
      lat = parseFloat(data?.legalLatitude);
      lng = parseFloat(data?.legalLongitude);
    }

    if (isNaN(lat) || isNaN(lng)) {
      if (type === "billing") {
        lat = parseFloat(data?.billingStreet?.latitude);
        lng = parseFloat(data?.billingStreet?.longitude);
      } else if (type === "legal") {
        lat = parseFloat(data?.legalStreet?.latitude);
        lng = parseFloat(data?.legalStreet?.longitude);
      }
    }

    if (!isNaN(lat) && !isNaN(lng)) {
      setCenter({ lat, lng });
    } else {
      setCenter(defaultCenter);
    }
  }, [
    type,
    type === "billing" ? data?.billingLatitude : data?.legalLatitude,
    type === "billing" ? data?.billingLongitude : data?.legalLongitude,
    type === "billing" ? data?.billingStreet : data?.legalStreet,
  ]);

  useEffect(() => {
    if (data?.billingAndLegalAddressSame === true && type === "legal") {
      setOptions({
        disableDefaultUI: true,
        zoomControl: false,
        panControl: false,
        rotateControl: false,
        scaleControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        keyboardShortcuts: false,
        gestureHandling: "none",
      });
    } else {
      setOptions({
        disableDefaultUI: true,
        zoomControl: false,
        panControl: false,
        rotateControl: false,
        scaleControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        keyboardShortcuts: false,
        gestureHandling: "greedy",
      });
    }
  }, [data?.billingAndLegalAddressSame]);

  return (
    isLoaded && (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        options={options}
        onLoad={(map) => {
          mapRef.current = map;
        }}
      >
        <Marker
          position={center}
          draggable={true}
          onDragEnd={(e) => {
            const newLat = e.latLng?.lat();
            const newLng = e.latLng?.lng();
            if (type === "billing") {
              setData((prev) => ({
                ...prev,
                billingLatitude: newLat,
                billingLongitude: newLng,
              }));
              setErrors((prev) => ({
                ...prev,
                billingLatitude: "",
                billingLongitude: "",
              }));
            }
            if (type === "legal") {
              setData((prev) => ({
                ...prev,
                legalLatitude: newLat,
                legalLongitude: newLng,
              }));
              setErrors((prev) => ({
                ...prev,
                legalLatitude: "",
                legalLongitude: "",
              }));
            }
          }}
          icon={
            window.google
              ? {
                  url: `${process.env.REACT_APP_PUBLIC_URL}icons/branch.png`,
                  scaledSize: new window.google.maps.Size(50, 50),
                }
              : undefined
          }
        />
      </GoogleMap>
    )
  );
};

export default AddressMap;
